module.exports = __webpack_public_path__ + "static/media/thewest-banner-black-friday.ac05883a.png";